import type { SVGProps } from 'react';
import { logger } from '@ui/utils/logger';

import { icons, type IconName } from './index';

interface IIcon extends Omit<SVGProps<SVGSVGElement>, 'name'> {
    name: IconName;
    size?: number;
}

export const Icon = ({ name, size = 16, className = 'icon', color, style, ...props }: IIcon) => {
    const IconComponent = icons[name];

    if (!IconComponent) {
        logger.warn(`Icon "${name}" does not exist`);
        return null;
    }

    return (
        <IconComponent
            width={size}
            height={size}
            className={className}
            style={color ? { ...style, color } : style}
            {...props}
        />
    );
};
